const middleware = {}

middleware['certificate'] = require('../middleware/certificate.js')
middleware['certificate'] = middleware['certificate'].default || middleware['certificate']

export default middleware
